import { useEffect, useState } from 'react'
import { supabase } from '@/supabase-client'

const IN_PROGRESS_STATES = ['approved', 'onboarding_in_progress', 'submitted_for_review']
const REJECTED_WINDOW_DAYS = 14

export function useRegistrationPipeline() {
  const [pending, setPending] = useState([])
  const [inProgress, setInProgress] = useState([])
  const [rejected, setRejected] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false

    const refresh = async () => {
      const since = new Date(Date.now() - REJECTED_WINDOW_DAYS * 24 * 60 * 60 * 1000).toISOString()

      const [pendingRes, inProgressRes, rejectedRes] = await Promise.all([
        supabase
          .from('portal_registration_requests')
          .select('id, business_name, contact_name, email, phone, message, created_at')
          .eq('status', 'interest_submitted')
          .order('created_at', { ascending: true }),
        supabase
          .from('portal_registration_requests')
          .select('id, business_name, contact_name, email, status, approved_at, created_at')
          .in('status', IN_PROGRESS_STATES)
          .order('approved_at', { ascending: true, nullsFirst: false }),
        supabase
          .from('portal_registration_requests')
          .select('id, business_name, contact_name, email, rejection_reason, reviewed_at')
          .eq('status', 'rejected')
          .gte('reviewed_at', since)
          .order('reviewed_at', { ascending: false }),
      ])

      if (cancelled) return
      setPending(pendingRes.data || [])
      setInProgress(inProgressRes.data || [])
      setRejected(rejectedRes.data || [])
      setLoading(false)
    }

    refresh()

    const channel = supabase
      .channel('portal_registration_requests:pipeline')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'portal_registration_requests' },
        () => refresh()
      )
      .subscribe()

    return () => {
      cancelled = true
      supabase.removeChannel(channel)
    }
  }, [])

  return { pending, inProgress, rejected, loading }
}
